<!--
 * @Author: 何明 bxheming@163.com
 * @Date: 2025-04-27 16:23:13
 * @LastEditors: 何明 bxheming@163.com
 * @LastEditTime: 2025-08-06 15:55:35
 * @FilePath: \test_vue\src\components\HelloWorld.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div style="display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;">
    <!-- 111111111111111111111111111111111111111111111111111111111111111111111111111111111111 -->
    <div class="box">
      <div> <span>ip:</span> <span>{{ dataobj.ip_addresses[0] }}</span> (洛杉矶杭州公共1)</div>
      <div> <span>计划流量:</span> <span>{{ (Math.round(dataobj.plan_monthly_data / (1024 ** 3))) + ' GB' }}</span></div>
      <div> <span>已使用流量:</span> <span>{{ (dataobj.data_counter / (1024 ** 3)).toFixed(3) + ' GB' }}</span></div>
      <div style="display: flex;">
        <div> 已使用百分比 : </div>
        <div style="width: 50%;height: 100%;" v-if="dataobj.error==0"> <el-progress :text-inside="true" :stroke-width="26"
            :percentage="((dataobj.data_counter / dataobj.plan_monthly_data) * 100).toFixed(2)">>
          </el-progress></div>
             <div style="width: 50%;height: 100%;"  v-else> 
            <el-progress :text-inside="true" :stroke-width="26"
            :percentage="0">>
          </el-progress>
          </div>

      </div>
      <div> <span> 流量重置日期 :</span>{{ formattedDate }}</div>
    </div>
    <div class="box">
      <div> <span>ip:</span> <span>{{ dataobjC.ip_addresses[0] }}</span> （洛杉矶杭州公共2）</div>
      <div> <span>计划流量:</span> <span>{{ (Math.round(dataobjC.plan_monthly_data / (1024 ** 3))) + ' GB' }}</span></div>
      <div> <span>已使用流量:</span> <span>{{ (dataobjC.data_counter / (1024 ** 3)).toFixed(3) + ' GB' }}</span></div>
      <div style="display: flex;">
        <div> 已使用百分比 : </div>
        <div style="width: 50%;height: 100%;"  v-if="dataobjC.error==0"> <el-progress :text-inside="true" :stroke-width="26"
            :percentage="((dataobjC.data_counter / dataobjC.plan_monthly_data) * 100).toFixed(2)">>
          </el-progress></div>
          <div style="width: 50%;height: 100%;"  v-else> 
            <el-progress :text-inside="true" :stroke-width="26"
            :percentage="0">>
          </el-progress>
          </div>
          


      </div>
      <div> <span> 流量重置日期 :</span>{{ formattedDateC }}</div>
    </div>
    <div class="box">
      <div> <span>ip:</span> <span>{{ dataobjB.ip_addresses[0] }}</span> (洛杉矶直播中转1)</div>
      <div> <span>计划流量:</span> <span>{{ (Math.round(dataobjB.plan_monthly_data / (1024 ** 3))) + ' GB' }}</span></div>
      <div> <span>已使用流量:</span> <span>{{ (dataobjB.data_counter / (1024 ** 3)).toFixed(3) + ' GB' }}</span></div>
      <div style="display: flex;">
        <div> 已使用百分比 : </div>
        <div style="width: 50%;height: 100%;" v-if="dataobjB.error==0"> <el-progress :text-inside="true" :stroke-width="26"
            :percentage="((dataobjB.data_counter / dataobjB.plan_monthly_data) * 100).toFixed(2)">>
          </el-progress></div>
               <div style="width: 50%;height: 100%;"  v-else> 
            <el-progress :text-inside="true" :stroke-width="26"
            :percentage="0">>
          </el-progress>
          </div>

      </div>
      <div> <span> 流量重置日期 :</span>{{ formattedDateB }}</div>
    </div>
    <div class="box">
      <div> <span>ip:</span> <span>{{ dataobjE.ip_addresses[0] }}</span>（洛杉矶直播中转2）</div>
      <div> <span>计划流量:</span> <span>{{ (Math.round(dataobjE.plan_monthly_data / (1024 ** 3))) + ' GB' }}</span></div>
      <div> <span>已使用流量:</span> <span>{{ (dataobjE.data_counter / (1024 ** 3)).toFixed(3) + ' GB' }}</span></div>
      <div style="display: flex;">
        <div> 已使用百分比 : </div>
        <div style="width: 50%;height: 100%;" v-if="dataobjE.error==0"> <el-progress :text-inside="true" :stroke-width="26"
            :percentage="((dataobjE.data_counter / dataobjE.plan_monthly_data) * 100).toFixed(2)">>
          </el-progress></div>
               <div style="width: 50%;height: 100%;"  v-else> 
            <el-progress :text-inside="true" :stroke-width="26"
            :percentage="0">>
          </el-progress>
          </div>
      </div>
      <div> <span> 流量重置日期 :</span>{{ formattedDateE }}</div>
    </div>
    <div class="box">
      <div> <span>ip:</span> <span>{{ dataobjF.ip_addresses[0] }}</span>（王军爬虫）</div>
      <div> <span>计划流量:</span> <span>{{ (Math.round(dataobjF.plan_monthly_data / (1024 ** 3))) + ' GB' }}</span></div>
      <div> <span>已使用流量:</span> <span>{{ (dataobjF.data_counter / (1024 ** 3)).toFixed(3) + ' GB' }}</span></div>
      <div style="display: flex;">
        <div> 已使用百分比 : </div>
        <div style="width: 50%;height: 100%;" v-if="dataobjF.error==0"> <el-progress :text-inside="true" :stroke-width="26"
            :percentage="((dataobjF.data_counter / dataobjF.plan_monthly_data) * 100).toFixed(2)">>
          </el-progress></div>
              <div style="width: 50%;height: 100%;"  v-else> 
            <el-progress :text-inside="true" :stroke-width="26"
            :percentage="0">>
          </el-progress>
          </div>

      </div>
      <div> <span> 流量重置日期 :</span>{{ formattedDateF }}</div>
    </div>
    <!-- 2222222222222222222222222222222222222222222222222222 -->

    <!-- 33333333333333333333333333333333333333333 -->

    <!-- 444444444444444444444444444444444444444444444 -->

    <!-- 555555555555555555555555555555555 -->
    <div class="box">
      <div> <span>ip:</span> <span>{{ dataobjD.ip_addresses[0] }}</span>（洛杉矶ainop邮件）</div>
      <div> <span>计划流量:</span> <span>{{ (Math.round(dataobjD.plan_monthly_data / (1024 ** 3))) + ' GB' }}</span></div>
      <div> <span>已使用流量:</span> <span>{{ (dataobjD.data_counter / (1024 ** 3)).toFixed(3) + ' GB' }}</span></div>
      <div style="display: flex;">
        <div> 已使用百分比 : </div>
        <div style="width: 50%;height: 100%;" v-if="dataobjD.error==0">
           <el-progress :text-inside="true" :stroke-width="26"
            :percentage="((dataobjD.data_counter / dataobjD.plan_monthly_data) * 100).toFixed(2)">>
          </el-progress></div>
                 <div style="width: 50%;height: 100%;"  v-else> 
            <el-progress :text-inside="true" :stroke-width="26"
            :percentage="0">>
          </el-progress>
          </div>

      </div>
      <div> <span> 流量重置日期 :</span>{{ formattedDateD }}</div>
    </div>
    <div class="box">
      <div> <span>ip:</span> <span>{{ dataobjA.ip_addresses[0] }}</span>(洛杉矶OWA邮件) </div>
      <div> <span>计划流量:</span> <span>{{ (Math.round(dataobjA.plan_monthly_data / (1024 ** 3))) + ' GB' }}</span></div>
      <div> <span>已使用流量:</span> <span>{{ (dataobjA.data_counter / (1024 ** 3)).toFixed(3) + ' GB' }}</span></div>
      <div style="display: flex;">
        <div> 已使用百分比 : </div>
        <div style="width: 50%;height: 100%;" v-if="dataobjA.error==0"> <el-progress :text-inside="true" :stroke-width="26"
            :percentage="((dataobjA.data_counter / dataobjA.plan_monthly_data) * 100).toFixed(2)">>
          </el-progress></div>
                   <div style="width: 50%;height: 100%;"  v-else> 
            <el-progress :text-inside="true" :stroke-width="26"
            :percentage="0">>
          </el-progress>
          </div>


      </div>
      <div> <span> 流量重置日期 :</span>{{ formattedDateA }}</div>
    </div>
    <!-- 666666666666666666666666666666666666 -->
    <div class="box">
      <div> <span>ip:</span> <span>{{ dataobjG.ip_addresses[0] }}</span> (洛杉矶菲律宾直播中转1) </div>
      <div> <span>计划流量:</span> <span>{{ (Math.round(dataobjG.plan_monthly_data / (1024 ** 3))) + ' GB' }}</span></div>
      <div> <span>已使用流量:</span> <span>{{ (dataobjG.data_counter / (1024 ** 3)).toFixed(3) + ' GB' }}</span></div>
      <div style="display: flex;">
        <div> 已使用百分比 : </div>
        <div style="width: 50%;height: 100%;" v-if="dataobjG.error==0"> 
          <el-progress :text-inside="true" :stroke-width="26"
            :percentage="((dataobjG.data_counter / dataobjG.plan_monthly_data) * 100).toFixed(2)"> >
          </el-progress>
        </div>
               <div style="width: 50%;height: 100%;" v-else> 
          <el-progress :text-inside="true" :stroke-width="26"
            :percentage="0" >
          </el-progress>
        </div>

      </div>
      <div> <span> 流量重置日期 :</span>{{ formattedDateA }}</div>
    </div>
    <!-- 77777777777777777777777777777777777777 -->
    <div class="box">
      <div> <span>ip:</span> <span>{{ dataobjH.ip_addresses[0] }}</span> (洛杉矶乐毅美区) </div>
      <div> <span>计划流量:</span> <span>{{ (Math.round(dataobjH.plan_monthly_data / (1024 ** 3))) + ' GB' }}</span></div>
      <div> <span>已使用流量:</span> <span>{{ (dataobjH.data_counter / (1024 ** 3)).toFixed(3) + ' GB' }}</span></div>
      <div style="display: flex;">
        <div> 已使用百分比 : </div>
        <div style="width: 50%;height: 100%;" v-if="dataobjH.error==0"> <el-progress :text-inside="true" :stroke-width="26"
            :percentage="((dataobjH.data_counter / dataobjH.plan_monthly_data) * 100).toFixed(2)">>
          </el-progress></div>
                   <div style="width: 50%;height: 100%;"  v-else> 
            <el-progress :text-inside="true" :stroke-width="26"
            :percentage="0">>
          </el-progress>
          </div>


      </div>
      <div> <span> 流量重置日期 :</span>{{ formattedDateH }}</div>
    </div>

  </div>
</template>



<!-- Add "scoped" attribute to limit CSS to this component only -->

<script>
import axios from 'axios';
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },

  data () {
    return {
      dataobj: {}, // 存储接口返回的数据
      dataobjA: {}, // 存储接口返回的数据

      dataobjB: {}, // 存储接口返回的数据

      dataobjC: {}, // 存储接口返回的数据

      dataobjD: {}, // 存储接口返回的数据

      dataobjE: {}, // 存储接口返回的数据
      dataobjF: {}, // 存储接口返回的数据
      dataobjG: {}, // 存储接口返回的数据
      dataobjH: {}, // 存储接口返回的数据



      // 表单校验

    }
  },
  mounted () {
    this.fetchData(); // 在组件挂载时调用接口
  },
  computed: {
    formattedDate () {
      const date = new Date(this.dataobj.data_next_reset * 1000);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1并格式化
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    formattedDateA () {
      const date = new Date(this.dataobjA.data_next_reset * 1000);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1并格式化
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    formattedDateB () {
      const date = new Date(this.dataobjB.data_next_reset * 1000);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1并格式化
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    formattedDateC () {
      const date = new Date(this.dataobjC.data_next_reset * 1000);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1并格式化
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    formattedDateD () {
      const date = new Date(this.dataobjD.data_next_reset * 1000);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1并格式化
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    formattedDateE () {
      const date = new Date(this.dataobjE.data_next_reset * 1000);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1并格式化
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    formattedDateF () {
      const date = new Date(this.dataobjF.data_next_reset * 1000);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1并格式化
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    formattedDateG () {
      const date = new Date(this.dataobjG.data_next_reset * 1000);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1并格式化
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    formattedDateH () {
      const date = new Date(this.dataobjH.data_next_reset * 1000);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1并格式化
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
  },
  methods: {
    fetchData () {
      var that = this;
      axios.get(this.HOST + "/v1/getServiceInfo?veid=1958855&api_key=private_hWyZJTmdJJqOVhECoqJgvSKI")
        .then(function (response) {
               if (response.data.error!=0) {
            that.dataobj = {  ip_addresses:[''],
              plan_monthly_data: null,
              data_counter: 0,
              data_next_reset: 0,
              data_reset_interval: 0 ,
             };
        
          }else{
       
          // handle success
          that.dataobj = response.data;
        }

        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        .then(function () {
          // always executed
        });

      axios.get(this.HOST + "/v1/getServiceInfo?veid=1972259&api_key=private_0HXd5GrVFBMz2xQUIuk9sTWO")
        .then(function (response) {
          console.log(response);
             if (response.data.error!=0) {
            that.dataobjA = {  ip_addresses:[''],
                plan_monthly_data: null,
              data_counter: 0,
              data_next_reset: 0,
              data_reset_interval: 0 ,
             };
        
          }else{
          // handle success
          that.dataobjA = response.data;
        }

        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        .then(function () {
          // always executed
        });

      axios.get(this.HOST + "/v1/getServiceInfo?veid=1989276&api_key=private_62tYgqmWN0KfT1dvgAfGWSvX")
        .then(function (response) {
          console.log(response);
          // handle success
                if (response.data.error!=0) {
            that.dataobjB = {
               ip_addresses:[''],
               plan_monthly_data: null,
              data_counter: 0,
              data_next_reset: 0,
              data_reset_interval: 0 ,
            };
        
          }else{
          that.dataobjB = response.data;
        }

        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        .then(function () {
          // always executed
        });

      axios.get(this.HOST + "/v1/getServiceInfo?veid=1990051&api_key=private_cUsXNZLnnyyHzfEgat4j34uH")
        .then(function (response) {
         
          if (response.data.error!=0) {
            that.dataobjC = {  ip_addresses:[''],
              plan_monthly_data: null,
              data_counter: 0,
              data_next_reset: 0,
              data_reset_interval: 0 ,
             };
        
          }else{
          that.dataobjC = response.data;
             console.log(response,'2222222222222222222');
          }
          // handle success
    

        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        .then(function () {
          // always executed
        });

      axios.get(this.HOST + "/v1/getServiceInfo?veid=1990942&api_key=private_ffReM0EevXKtZgdqLlpfCEC1")
        .then(function (response) {
          console.log(response);
                   if (response.data.error!=0) {
            that.dataobjD = {  ip_addresses:[''],
               plan_monthly_data: null,
              data_counter: 0,
              data_next_reset: 0,
              data_reset_interval: 0 ,
             };
        
          }else{
          // handle success
          that.dataobjD = response.data;
        }

        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        .then(function () {
          // always executed
        });

      axios.get(this.HOST + "/v1/getServiceInfo?veid=1993613&api_key=private_cgzO4aKx6u4POXABZd0BVIZb")
        .then(function (response) {
          console.log(response);
             if (response.data.error!=0) {
            that.dataobjE = {  ip_addresses:[''],
              plan_monthly_data: null,
              data_counter: 0,
              data_next_reset: 0,
              data_reset_interval: 0 ,
             };
        
          }else{
          // handle success
          that.dataobjE = response.data;
        }

        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        .then(function () {
          // always executed
        });
      axios.get(this.HOST + "/v1/getServiceInfo?veid=1994757&api_key=private_uLQcTAcAB1NWWTU9WYPORKb5")
        .then(function (response) {
          console.log(response);
                       if (response.data.error!=0) {
            that.dataobjF = {  ip_addresses:[''],
                plan_monthly_data: null,
              data_counter: 0,
              data_next_reset: 0,
              data_reset_interval: 0 ,
             };
        
          }else{
          // handle success
          that.dataobjF = response.data;
        }

        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        .then(function () {
          // always executed
        });
      axios.get(this.HOST + "/v1/getServiceInfo?veid=1998083&api_key=private_lV5L7JVWB26egnXzRKSRLLjj")
        .then(function (response) {
          console.log(response);
          // handle success
                            if (response.data.error!=0) {
            that.dataobjG = {  ip_addresses:[''],
  plan_monthly_data: null,
              data_counter: 0,
              data_next_reset: 0,
              data_reset_interval: 0 ,
             };
        
          }else{
          that.dataobjG = response.data;
        }

        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        .then(function () {
          // always executed
        });

      axios.get(this.HOST + "/v1/getServiceInfo?veid=1999278&api_key=private_S18FE719HmwrlXgwH8gM34ps")
        .then(function (response) {
          console.log(response);
            if (response.data.error!=0) {
            that.dataobjH = {  ip_addresses:[''],
                plan_monthly_data: null,
              data_counter: 0,
              data_next_reset: 0,
              data_reset_interval: 0 ,
             };
        
          }else{
          // handle success
          that.dataobjH = response.data;
        }

        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        .then(function () {
          // always executed
        });


    }
  }
}
</script>
<style scoped>
.box {
  width: 20%;
  height: 100%;
  border-radius: 4px;
  background-color: #95a99536;
  border-color: #c2e7b0;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  padding: 20px;
  text-align: left;
  margin: 0 10px 10px 0;
}
</style>
